var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1rem",
    height: 12.75,
    viewBox: "0 0 17 12.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "envelope-regular_2_",
    "data-name": "envelope-regular (2)",
    d: "M2.125,65.594a.533.533,0,0,0-.531.531v.734l5.728,4.7a1.857,1.857,0,0,0,2.361,0l5.724-4.7v-.734a.533.533,0,0,0-.531-.531Zm-.531,3.327v5.7a.533.533,0,0,0,.531.531h12.75a.533.533,0,0,0,.531-.531v-5.7l-4.715,3.871a3.453,3.453,0,0,1-4.383,0ZM0,66.125A2.127,2.127,0,0,1,2.125,64h12.75A2.127,2.127,0,0,1,17,66.125v8.5a2.127,2.127,0,0,1-2.125,2.125H2.125A2.127,2.127,0,0,1,0,74.625Z",
    transform: "translate(0 -64)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.93ae32be52e91c7f28277b22d6cfb9e8.svg";
export { ForwardRef as ReactComponent };